import React from "react";
import Navbar from "./components/sections/Navbar";
import Hero from "./components/sections/Hero";
import StatsBar from "./components/sections/StatsBar";
import About from "./components/sections/About";
import Services from "./components/sections/Services";
import WhyUs from "./components/sections/WhyUs";
import Process from "./components/sections/Process";
import Testimonials from "./components/sections/Testimonials";
import Faq from "./components/sections/Faq";
import CtaFinal from "./components/sections/CtaFinal";
import Contact from "./components/sections/Contact";
import Footer from "./components/sections/Footer";
import FloatingWhatsApp from "./components/sections/FloatingWhatsApp";
import StructuredData from "./components/seo/StructuredData";
import "./App.css";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <StructuredData />
      <Navbar />
      <main>
        <Hero />
        <StatsBar />
        <About />
        <Services />
        <WhyUs />
        <Process />
        <Testimonials />
        <Faq />
        <CtaFinal />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
